import { createConsumer } from '@rails/actioncable';

const App = (window.App ||= {});
App.cable = createConsumer();

import './channels/signature_channel';
import './channels/subscription_intention_channel';
